"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/careerbrewery/careerbrewery.scss');
const index_1 = require("./../js/index");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
// Import site specific scripts
//require("./Sites/careerbrewery");
